import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import * as jwt_decode from 'jwt-decode';
import * as moment from 'moment';
import 'rxjs/add/operator/delay';

import { environment } from '../../../environments/environment';
import { of, EMPTY, Observable, BehaviorSubject } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'user-key': environment.apiKey,
        'X-Tenant-ID': environment.clientID
    })
};

@Injectable({
    providedIn: 'root'
})
export class FeatureService {
    private features = new Set<string>();
    private endpoint: string;

    constructor(private http: HttpClient) {
        this.endpoint = environment.apiUrl;
    }

    loadFeatures(): Observable<string[]> {
        return this.http.get<string[]>(this.endpoint + `/clients/features?clientId=${environment.clientID}`, httpOptions).pipe(tap(arr => this.features = new Set(arr)));
    }

    hasFeature(name: string): boolean {
        return this.features.has(name);
    }
}
